import { RES_AFREECATV, STATION_URL } from "constant/config";
import {
    ADMIN_DELETE,
    BJ_HIDDEN,
    ENCODING,
    ENCODING_FAIL,
    ENCODING_WAIT,
    FILTERING,
    SUCCEED,
    TIMEOUT_DELETE,
    UPLOADING,
    UPLOAD_FAIL,
} from "constant/video.status";
import { DEFAULT_PROFILE_IMAGE_URL, DEFAULT_THUMBNAIL_IMAGE_URL, handleThumbnailOnerror } from "listeners/error.listener";
import React, { useState } from "react";
import { Trans } from "react-i18next";

/**
 * 프로파일이미지
 * @param {*} props
 */
export const ProfileImage = ({ userId, src = DEFAULT_PROFILE_IMAGE_URL, className = "thumb" }) => {

    /**
     * 프로필 클릭시 방송국으로 이동
     */
    const handleGoStation = (event) => {
        if(userId) {
            event.preventDefault();
            window.open(`${STATION_URL}/${userId}`);
        }
    }
    
    return <div className={className} style={{ backgroundImage: `url(${src}) ` }} onClick={handleGoStation} />;
};

/**
 * 게시판이미지
 * @param {*} props
 */
export const BoardImage = (props) => {
    return <img {...props} src={props.src} alt="" onError={handleThumbnailOnerror()} loading="lazy" />;
};

/**
 * 게시판이미지
 * @param {*} props
 */
export const VideoImage = ({ vod }) => {
    const { ucc = {}, auth_no, copyright, is_reserve } = vod;
    const { flag = SUCCEED, grade } = ucc;
    const isAdult = grade === 19; //성인여부
    const [imgError, setImgError] = useState(false);

    const handleVodImageError = (e) => {
        setImgError(true);
    };

    switch (flag) {
        // 임시 적용 - 추후 변경해야됨 : 영상이 권한에 안맞을 경우 기본 썸네일 노출
        case "AUTH_DENIED":
            return <img src={DEFAULT_THUMBNAIL_IMAGE_URL} alt="" loading="lazy" />;

        case TIMEOUT_DELETE:
            return <img src={`${RES_AFREECATV}/images/mobile/mybs/img_expire.jpg`} alt="" loading="lazy" />;

        case ENCODING_FAIL:
            return(
                <span className="thumb-encoding">
                    <em><Trans>Mã hóa sự thất bại</Trans></em>
                </span>
            );
        case FILTERING:
        case UPLOAD_FAIL:
            return(
                <span className="thumb-upload">
                    <em><Trans>tải lên sự thất bại</Trans></em>
                </span>
            );
        case ADMIN_DELETE:
            return(
                <span className="thumb-del">
                    <em><Trans>Nhà điều hành xóa bỏ</Trans></em>
                </span>
            );
        case ENCODING:
        case ENCODING_WAIT:
        case UPLOADING:
            return(
                <span className="thumb-converting">
                    <em><Trans>VOD Chuyển đổi</Trans></em>
                </span>
            );

        case BJ_HIDDEN:
            return isAdult === true ? (
                <span className="thumb-lock_adult">
                    <Trans>19vàng + Xúc phạm</Trans>
                </span>
            ) : (
                <span className="thumb-lock">
                    <Trans>Xúc phạm</Trans>
                </span>
            );

        case SUCCEED:
        default:
            if (copyright && copyright.del_flag === "Y") {
                return (
                    <div className="thumb-text">
                        <p>
                            <Trans>Phát tin BJĐẾN bởi vì  mù Xử lý VOD không thấy</Trans>
                        </p>
                    </div>
                );
            } else {
                if (auth_no === 102 && is_reserve !== true) {
                    //비공개
                    return isAdult === true ? (
                        <span className="thumb-lock_adult">
                            <Trans>19vàng + Xúc phạm</Trans>
                        </span>
                    ) : (
                        <span className="thumb-lock">
                            <Trans>Xúc phạm</Trans>
                        </span>
                    );
                } else if (isAdult === true) {
                    return (
                        <span className="thumb-adult">
                            <Trans>19vàng</Trans>
                        </span>
                    );
                } else {
                    if (imgError) {
                        return (
                            <span className="thumb-default">
                                <Trans>hình nhỏ</Trans>
                            </span>
                        );
                    } else {
                        return <img src={ucc.thumb} alt="" onError={handleVodImageError} loading="lazy" />;
                    }
                }
            }
    }
};
